
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.715 3.154a.5.5 0 01-.014.707l-12.5 12a.5.5 0 01-.692-.722l12.5-12a.5.5 0 01.706.015zm-1.952 3.971a.5.5 0 01.7-.11c.77.563 1.48 1.201 2.123 1.906l.002.002a1.609 1.609 0 010 2.153l-.001.002C15.84 13 12.943 15.046 9.998 14.999a7.155 7.155 0 01-2.17-.321.5.5 0 11.297-.955 6.158 6.158 0 001.872.276h.012c2.52.043 5.163-1.751 6.837-3.593a.609.609 0 000-.813 13.215 13.215 0 00-1.973-1.77.5.5 0 01-.11-.698zM10 5a6.866 6.866 0 011.728.204.5.5 0 11-.241.97 5.866 5.866 0 00-1.483-.173h-.013C7.515 5.96 4.864 7.714 3.156 9.593a.609.609 0 000 .813 13.3 13.3 0 001.669 1.54.5.5 0 01-.613.79 14.376 14.376 0 01-1.796-1.657l-.003-.003a1.609 1.609 0 010-2.153l.002-.002C4.2 6.958 7.103 4.956 10 5.001z","fill":"#5C6970"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.998 7.999a2 2 0 00-2 2 .5.5 0 11-1 0 3 3 0 013-3 .5.5 0 110 1zM12.5 9.5a.5.5 0 01.5.5 2.999 2.999 0 01-3 3 .5.5 0 010-1 2 2 0 002-2 .5.5 0 01.5-.5z","fill":"#5C6970"}})])
          )
        }
      }
    